import { render } from "./ViewUser.vue?vue&type=template&id=40083e0e&ts=true"
import script from "./ViewUser.ts?vue&type=script&lang=ts"
export * from "./ViewUser.ts?vue&type=script&lang=ts"

import "./ViewUser.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__